import type { ReactElement } from "react";
import { useTranslation } from "react-i18next";
import { LaborCostDetailsTableHeader } from "@/pages/human-resources/time-management/schedules/site-schedule/analysis/labor-cost-details/LaborCostDetailsTableHeader.tsx";
import type { LaborCostSection } from "@/pages/human-resources/time-management/business/analysis/LaborCostSection.ts";
import { LaborCostDetailsSection } from "@/pages/human-resources/time-management/schedules/site-schedule/analysis/labor-cost-details/LaborCostDetailsSection.tsx";
import "./LaborCostDetailsTable.scss";

interface LaborCostDetailsTableProps {
  sections: LaborCostSection[];
}

export function LaborCostDetailsTable({
  sections,
}: LaborCostDetailsTableProps): ReactElement {
  const { t } = useTranslation("common");

  return (
    <table className="labor-cost-details-table">
      <LaborCostDetailsTableHeader />
      <tbody>
        {sections.length === 0 ?
          <tr>
            <td className="no-data-cell" colSpan={8}>
              {t("noResultsFound")}
            </td>
          </tr>
        : sections.map((section) => (
            <LaborCostDetailsSection
              key={section.sectionId}
              section={section}
            />
          ))
        }
      </tbody>
    </table>
  );
}
